// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__lmvta","wrapper__input":"Editable_wrapper__input__VLLc7","wrapper__toolbarBtn":"Editable_wrapper__toolbarBtn__LXVJW"};